import { HubConnectionState } from '@microsoft/signalr';
import { stringify } from 'qs';
import { toast } from 'sonner';

import { useLogSignalR } from 'store/logger';

import { useDeviceName } from 'lib/api/myRobot';

import { logRed } from 'utils/debugger';

import { HUB_URL } from '../const';
import { Options } from './types';
import { useSignalRHubBasic } from './useSignalRHubBasic';

// WIP
//export const SIGNAL_R_PROXY_PREFIX = '/api/proxy/ws';

type QueryParams = Record<string, unknown>;

/**
 * Create url for signalR connection
 * @param url
 * @param params
 */
export const createUrl = (url: string, params?: QueryParams) => {
  if (url === HUB_URL.TWIN) {
    return `${global.clientConfig?.StatekeepingUrl}/${url}`;
  }

  // if url match to HUB_URL enum, then it's a signalR hub
  if (Object.values(HUB_URL).includes(url as HUB_URL)) {
    // todo - this is WIP for proxy signalR
    // return `${SIGNAL_R_PROXY_PREFIX}/${url}?${stringify(params)}`;
    // console.log('${process.env.BACKEND_URL}/${url}', `${global.clientConfig?.BackendUrl}/${url}`);
  }

  return `${global.clientConfig?.BackendUrl}/${url}?${stringify(params)}`;
};

/**
 * Create and initialize a connection to a signalR hub
 */
export function useSignalRConnection(url: HUB_URL) {
  const { deviceName } = useDeviceName();
  const { logSignalRInit } = useLogSignalR(url);

  const hubOptions: Options = {
    onConnected: () => logSignalRInit(`signalR: 🏁🏁🏁 connection started: "${url}"`),
    onDisconnected: () => logSignalRInit(`signalR: 🛑🛑🛑 connection disconnected: "${url}"`),
    onError: (error) => {
      toast.error(
        error?.toString() || 'Something went wrong with signalR...\nPlease, try again later!',
      );
      logRed(`signalR: 🚫🚫🚫 connection error: "${url}"`, error);
    },
  };

  const connection = useSignalRHubBasic(createUrl(url, { deviceId: deviceName }), hubOptions);

  const isConnected = connection?.state === HubConnectionState.Connected;
  const status = connection?.state;

  return {
    connection,
    isConnected,
    status,
  };
}
